import { render } from "./MobileCalc.vue?vue&type=template&id=352750f3&scoped=true"
import script from "./MobileCalc.vue?vue&type=script&lang=js"
export * from "./MobileCalc.vue?vue&type=script&lang=js"

import "./MobileCalc.vue?vue&type=style&index=0&id=352750f3&lang=scss&scoped=true"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352750f3"]])

export default __exports__